
import Vue from "vue";
import { Sale, SaleHistory } from "@/models/base";
import {Reminder} from "@/models/reminder";
import {ReminderService} from "@/services/reminder-service";
import {AWSFileService} from "@/services/aws-file-service";
import { TranslateResult } from "vue-i18n";
import {printBoolean} from "@/utils/pretty-print";

export default Vue.extend({
	data(){
		return {
			reminder: new Reminder(),
			downloading: false
		};
	},
	props: {
		event: {
			type: Object as ()=>SaleHistory,
			required: true
		},
		sale: {
			type: Object as ()=>Sale,
			required: true
		}
	},
	computed: {
		fileName():string{
			return ReminderService.getPdfName(this.reminder.ReminderDate);
		}
	},
	methods: {
		printBooleanText(key:string, value:boolean):TranslateResult{
			let yesOrNo = printBoolean(value);
			return this.$ct(key, {value: yesOrNo});
		},
		async downloadReminder(){
			if (!this.reminder.File) return;
			if (this.downloading) return;
			this.downloading = true;
			try{
				await AWSFileService.downloadFile(this.reminder.File.Token, this.fileName);
			}catch(err){

			}finally{
				this.downloading = false;
			}
		}
	},
	async mounted(){
		this.reminder = await ReminderService.getReminder(parseInt(this.event.Props[1]));
	},
	i18nEx: {
		componentPrefix: "components.sales"
	},
});
